import { render, staticRenderFns } from "./NotificationSwitzerland.vue?vue&type=template&id=0fc6ac84&"
import script from "./NotificationSwitzerland.vue?vue&type=script&lang=js&"
export * from "./NotificationSwitzerland.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSwitzerland.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports